import * as common from 'store/modules/common'
import { api } from './api'

const newEntity = {
  id: 0,
  name: '',
  vintage: new Date().getFullYear(),
  wineStyle: null,
  grape: null,
  producer: null,
  subregion: null,
  expiration: new Date().getFullYear() + 2,
  description: '',
  loweIndex: 1,
  expQuality: 0,
  quality: 0,
  customerRating: 0,
  wineEvaluations: [],
  wsetEvaluations: [],
  holdingStrategy: 0,
  temperature: 0,
  bottleVolume: 2,
  imageIds: [],
  canBeDeleted: true
}

export const prefix = 'wines'

export { api }
export const initialState = { ...common.initialState }
export const actionTypes = { ...common.actionTypes(prefix) }
export const actionCreators = { ...common.actionCreators(prefix, api) }

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.create: return { ...state, entity: { ...newEntity, isDirty: true } }
    default: return common.reducer(state, action, prefix)
  }
}

